import { dataLayerPush } from '@libs/analytics';

export function trackFeatureBannerClick(name: string, bannerTitle: string) {
    dataLayerPush({
        event: 'FeatureBannerClick',
        bannerclick_name: name,
        bannerTitle,
    });
}
